import { MembersTableState, TeamMemberTableRowData } from '../../common/types';
import { State } from '../configure-store';
import { convertTeamMembersDataToTableData } from '../../services/team-table-data-convertor';
import { getTeamMembersList } from './teamMembers';
import { getRoles } from './roles';

export const getTable = (state: State): MembersTableState => state.membersTable;

export const getRoleIdsFromState = (state: State) => getRoleIds(state, convertTeamMembersDataToTableData(getTeamMembersList(state)));

// Creating an array of existing roles where each role is unique based on the members roles.
export const getRoleIds = (state: State, tableMembers: TeamMemberTableRowData[]) => {
  const roles = getRoles(state);
  return Array.from(tableMembers.reduce((acc, tableMember) => {
    tableMember.roles.forEach(role => acc.add(role));
    return acc;
    }, new Set<string>())).filter(roleId => roles.find(role => role.id === roleId));
};

export const getTableFilter = (state: State, roleIds: string[]): string[] =>
    state.membersTable.filters.roles[0] === 'all' ? roleIds : state.membersTable.filters.roles;
